import { computed } from 'vue';

import { storeToRefs } from 'pinia';

import { useCatalogFiltersStore } from '../stores/catalogFilters';

const useCatalogFilters = () => {
  const filterStore = useCatalogFiltersStore();
  const {
    getFacets,
    getCurrentFilters,
    getCurrentTags,
    getOptionCards,
    getCardSelected,
    getResults,
    getPageInfo,
    getLoading,
    getCurrentOrder,
    getAllResultsCount,
    getModalReservationFlag,
    getModalPreviewFlag,
    getActivityPreview,
    getCatalogCodeComponent,
    getCatalogModalComponent,
    getTitleDate,
    getFormattedDate,
    getSelectedSchedule,
    getAllTimeRanges,
  } = storeToRefs(filterStore);

  const init = async () => {
    await filterStore.init();
  };

  const handleChangeFilters = async (key, type) => {
    await filterStore.handleChangeFilters(key, type);
  };

  const getDataFromFilters = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const getTravel = async () => {
    const res = await filterStore.getTravel();
    return res;
  };

  const getBoxes = async () => {
    const res = await filterStore.getBoxes();
    return res;
  };

  const getActivities = async () => {
    const res = await filterStore.getActivities();
    return res;
  };

  const clearCurrentFilters = () => {
    filterStore.clearCurrentFilters();
  };

  const setCard = cardId => {
    filterStore.setCard(cardId);
  };
  const setBoxCategory = category => {
    filterStore.setBoxCategory(category);
  };

  const deleteTags = ({ key, inputType, value }) => {
    filterStore.deleteTags({ key, inputType, value });
  };

  const setKeywords = keywords => {
    filterStore.setKeywords(keywords);
  };

  const resetPaginationNumber = () => {
    filterStore.resetPaginationNumber();
  };

  const setBoxId = boxId => {
    filterStore.setBoxId(boxId);
  };

  const onToggleModalPreview = activityObject => {
    filterStore.onToggleModalPreview(activityObject);
  };

  const onToggleModalReservation = () => {
    filterStore.onToggleModalReservation();
  };

  const onActivityBySlug = async slug => {
    await filterStore.onActivityBySlug(slug);
  };

  const onSetTimeSlot = timeSlot => {
    filterStore.onSetTimeSlot(timeSlot);
  };

  const onSetDate = date => {
    filterStore.onSetDate(date);
  };

  const onSetSchedule = schedule => {
    filterStore.onSetSchedule(schedule);
  };

  const fetchTimeRanges = async () => {
    await filterStore.fetchTimeRanges();
  };

  const scrollToResultsStart = () => {
    const activitiesResultElement = document.getElementById(
      'catalogviewResultsContainer',
    );
    activitiesResultElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const updatePageNumber = pageNumber => {
    filterStore.updatePageNumber(pageNumber);
  };

  const setCatalogOrderType = orderType => {
    filterStore.setCatalogOrderType(orderType);
  };

  return {
    handleChangeFilters,
    getDataFromFilters,
    getTravel,
    getBoxes,
    getActivities,
    clearCurrentFilters,
    setCard,
    setBoxCategory,
    setKeywords,
    setBoxId,
    deleteTags,
    resetPaginationNumber,
    onToggleModalPreview,
    onToggleModalReservation,
    onActivityBySlug,
    updatePageNumber,
    getPageInfo: computed(() => getPageInfo.value),
    getFacets: computed(() => getFacets.value),
    getCurrentFilters: computed(() => getCurrentFilters.value),
    getCurrentTags: computed(() => getCurrentTags.value),
    getOptionCards: computed(() => getOptionCards.value),
    getCardSelected: computed(() => getCardSelected.value),
    getResults: computed(() => getResults.value),
    getLoading: computed(() => getLoading.value),
    getCurrentOrder: computed(() => getCurrentOrder.value),
    getAllResultsCount: computed(() => getAllResultsCount.value),
    getModalPreviewFlag: computed(() => getModalPreviewFlag.value),
    getModalReservationFlag: computed(() => getModalReservationFlag.value),
    getActivityPreview: computed(() => getActivityPreview.value),
    getCatalogCodeComponent: computed(() => getCatalogCodeComponent.value),
    getCatalogModalComponent: computed(() => getCatalogModalComponent.value),
    getTitleDate: computed(() => getTitleDate.value),
    getFormattedDate: computed(() => getFormattedDate.value),
    getSelectedSchedule: computed(() => getSelectedSchedule.value),
    getAllTimeRanges: computed(() => getAllTimeRanges.value),
    onSetTimeSlot,
    onSetDate,
    onSetSchedule,
    fetchTimeRanges,
    scrollToResultsStart,
    init,
    setCatalogOrderType,
  };
};

export default useCatalogFilters;
